import { render, staticRenderFns } from "./Landing3OurProduct1.vue?vue&type=template&id=54607326&scoped=true&"
import script from "./Landing3OurProduct1.vue?vue&type=script&lang=js&"
export * from "./Landing3OurProduct1.vue?vue&type=script&lang=js&"
import style0 from "./Landing3OurProduct1.vue?vue&type=style&index=0&id=54607326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54607326",
  null
  
)

export default component.exports